import {
  DomainExpirationsI,
  InvoiceSummaryI,
  UserNotificationsI,
  DomainExpirationItemI,
} from '@/modules/myServices/types/api/UserNotifications'
import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'

export default class UserNotifications {
  domainExpirations: DomainExpirationsCollection
  invoiceSummary: InvoiceSummary
  constructor(data: UserNotificationsI) {
    this.invoiceSummary = new InvoiceSummary(data.invoiceSummary)
    this.domainExpirations = new DomainExpirationsCollection(data.domainExpirations)

    ObjectCreationValidator.validate(this)
  }
}

export class DomainExpirationsCollection {
  domainExpirationForMonth: DomainExpirationItem
  domainExpirationForWeek: DomainExpirationItem
  constructor(data: DomainExpirationsI) {
    this.domainExpirationForMonth = new DomainExpirationItem(data.domainExpirationForMonth)
    this.domainExpirationForWeek = new DomainExpirationItem(data.domainExpirationForWeek)

    ObjectCreationValidator.validate(this)
  }
  get hasDomainExpirationForMonth(): boolean {
    return this.domainExpirationForMonth.isAboutToExpiry
  }
  get hasDomainExpirationForWeek(): boolean {
    return this.domainExpirationForWeek.isAboutToExpiry
  }
}

class DomainExpirationItem {
  count: number
  id: string | null
  constructor(domainExpirationItem: DomainExpirationItemI) {
    this.count = domainExpirationItem.count
    this.id = domainExpirationItem.id

    ObjectCreationValidator.validate(this)
  }
  get isAboutToExpiry() {
    return Boolean(this.count > 0 && this.id)
  }
}

class InvoiceSummary {
  overdueInvoiceCount: number
  overdueInvoiceTotal: number
  unpaidInvoiceCount: number
  invoiceId: number | null
  constructor(data: InvoiceSummaryI | null) {
    this.overdueInvoiceCount = data?.overdueInvoiceCount || 0
    this.overdueInvoiceTotal = data?.overdueInvoiceTotal || 0
    this.unpaidInvoiceCount = data?.unpaidInvoiceCount || 0
    this.invoiceId = data?.invoiceId || null

    ObjectCreationValidator.validate(this)
  }
}
